// extracted by mini-css-extract-plugin
export default {"formFooter":"formFooter_formFooter__x3f54","isPinned":"formFooter_isPinned__sExZX","bottomPinRef":"formFooter_bottomPinRef__Hs79S"};